import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { TypeaheadInputComponent } from '../components/typeahead-input.component';
import { getOptions, getValue } from '../services/typeahead-input.service';

export function TypeaheadInputContainer ({ placeholder, valueField, name, onTypeahead, isRequired, list, label, className, onValueChangeCallback, labelField, value }: any) {
  const [
    inputValue,
    setInputValue
  ] = useState({ event: null, value: getValue({ list, value, valueField, labelField }) });
  const [
    options,
    setOptions
  ] = useState(getOptions({ list, valueField, labelField }));
  const [open, setOpen] = useState(false);

  const handleButtonClick = () => {
    setOpen(!open);
  };
  useEffect(
    () => {
      setInputValue({ event: null, value: getValue({ list, value, valueField, labelField }) })
    },
    [value]
  )
  useEffect(
    () => {
      setOptions(getOptions({ list, valueField, labelField }))
      setInputValue({ event: null, value: getValue({ list, value, valueField, labelField }) })
    },
    [list]
  ) 
  
const debouncedHandleKeyDown = _.debounce((event: React.KeyboardEvent<HTMLInputElement>) => {
    onTypeahead((event.target as HTMLInputElement).value);
}, 500);

  return (<TypeaheadInputComponent
      className={className}
      isRequired={isRequired}
      label={label}
      labelField={labelField}
      name={name}
      handleKeyDown={debouncedHandleKeyDown}
    options={options}
    inputValue={inputValue}
    placeholder={placeholder}
    onValueChange={
      (event: any) => {
          setInputValue({ event, value:event.value });
          onValueChangeCallback(event.value)
      }
    }
      valueField={valueField}
      handleButtonClick={handleButtonClick}
      open={open}
          />
  )
}
